import { useUpdateBroadcastChannel } from '@mvecom/common/hooks/useUpdateBroadcastChannel';
import { AxiosError } from 'axios';
import { useCallback } from 'react';

import { Actions } from '../../actions/enums';
import { profileAxiosInstance as network } from '../../network/axios';
import { Endpoints, SiteTypes } from '../../network/enums';
import { endpointReplace } from '../../network/utils/endpointReplace';
import { getRetailUnitAndLanguage } from '../../network/utils/getRetailUnitAndLanguage';

export type LogoutAuthEvent =
  | { status: 'log-out-attempt-pending' }
  | { status: 'log-out-attempt-success' }
  | { status: 'log-out-attempt-failure'; error: AxiosError };

export const useIcapsLogout = (onAuthEvent?: (state: LogoutAuthEvent) => void) => {
  const broadcast = useUpdateBroadcastChannel('profile_pages_update', getRetailUnitAndLanguage().retailUnit);

  const logout = useCallback(
    (onSuccess?: () => void) => {
      onAuthEvent?.({ status: 'log-out-attempt-pending' });

      network
        .delete(endpointReplace({ ':siteType': SiteTypes.PROFILE }, Endpoints.Auth))
        .then(({ status }) => {
          const loggedOut = status >= 200 && status <= 202;

          if (loggedOut) {
            onAuthEvent?.({ status: 'log-out-attempt-success' });
            onSuccess?.();
            broadcast({
              type: 'profile',
              action: 'signed-out',
            });
            globalThis?.ikea?.pubsub?.publish?.(Actions.USER_LOGGED_OUT);
            globalThis?.ikea?.pubsub?.publish?.(Actions.USER_INFO_AVAILABLE);
          } else {
            onAuthEvent?.({
              status: 'log-out-attempt-failure',
              error: new AxiosError('Logout error status: ' + status, status.toString()),
            });
          }
        })
        .catch((e) => {
          if (e.response.data.type === 'error/irw-cookie-missing') {
            // consider user logged out if the IRW cookie is missing
            console.warn('You were already logged out (IRW cookie missing)');
            onAuthEvent?.({ status: 'log-out-attempt-success' });
            onSuccess?.();
            broadcast({
              type: 'profile',
              action: 'signed-out',
            });
            globalThis?.ikea?.pubsub?.publish?.(Actions.USER_INFO_AVAILABLE);
            globalThis?.ikea?.pubsub?.publish?.(Actions.USER_LOGGED_OUT);
          } else {
            console.log('error while logging out', e);
            onAuthEvent?.({ status: 'log-out-attempt-failure', error: e });
          }
        });
    },
    [broadcast, onAuthEvent],
  );

  return logout;
};
